import { render, staticRenderFns } from "./product2.vue?vue&type=template&id=a61d2530&scoped=true"
import script from "./product2.vue?vue&type=script&lang=js"
export * from "./product2.vue?vue&type=script&lang=js"
import style0 from "./product2.vue?vue&type=style&index=0&id=a61d2530&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61d2530",
  null
  
)

export default component.exports